import { faqs } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">关于每日大赛入口，您可能想了解的信息</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="rounded-xl bg-background-50 p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-question-answer-line"></i>
                  </span>
                </span>
                {faq.question}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-7">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}